import styled from 'styled-components';

export const HeaderBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 16px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white.senary};
`;

export const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  min-width: 0;
`;

export const LevelTitle = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.typography.quartenary};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: 500;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.black.quinary};
`;

export const XpRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const XpText = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.typography.quartenary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.black.textDark};

  strong {
    font-weight: 600;
  }
`;

export const RankingBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 8px 12px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.backgrounds.active};
  font-family: ${({ theme }) => theme.typography.quartenary};
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.green.quaternary_text};
`;

export const RankingTrophySlot = styled.span`
  display: inline-flex;
  line-height: 0;
  color: ${({ theme }) => theme.colors.green.quaternary_text};

  & .MuiSvgIcon-root {
    color: inherit !important;
    fill: currentColor !important;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: ${({ theme }) => theme.colors.gray.tertiary};
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ pct: number }>`
  height: 100%;
  width: ${({ pct }) => pct}%;
  border-radius: 3px;
  background: ${({ theme }) => theme.colors.brand.primary.main};
  transition: width 0.3s ease;
`;
